import { Spinner } from "@chakra-ui/react";
import "./PushableButton.css";

type IPushableButtonProps = {
  title: string;
  frontStyle?: React.CSSProperties;
  pushStyle?: React.CSSProperties;
  onClick?: () => void;
  isLoading?: boolean;
};

const PushableButton = ({
  title,
  frontStyle,
  pushStyle,
  isLoading,
  onClick,
}: IPushableButtonProps) => {
  return (
    <button
      onClick={isLoading ? () => {} : onClick}
      style={pushStyle}
      className="pushable"
    >
      <span style={frontStyle} className="front">
        {isLoading ? <Spinner /> : title}
      </span>
    </button>
  );
};

export default PushableButton;
